import { useQuery } from "@tanstack/react-query";
import { Navigate } from "react-router-dom";
import { isLoggedIn } from "../../../services/users.service";

interface RouterGuardComponent {
  children: string | React.ReactNode | React.ReactNode[];
  allowProctor?: boolean;
}
const RouterGuard = (props: RouterGuardComponent) => {
  const { children, allowProctor } = props;

  const handler = async () => {
    const result = await isLoggedIn();
    return result;
  };
  const { data, isLoading } = useQuery({
    queryKey: ["isLoggedInGuard"],
    queryFn: handler,
  });
  if (isLoading) {
    return <h1>Loading</h1>;
  }
  if (!allowProctor && data?.user?.role === "proctor") {
    return <Navigate to={"/SEABC/proctor"} />;
  }
  if (data?.isLogged) {
    return <>{children}</>;
  }
  return <Navigate to={"/SEABC/login"} />;
};

export default RouterGuard;
